__turbopack_context__.v({
  "copyright": "STFooter-module__o2ngqq__copyright",
  "dropdown": "STFooter-module__o2ngqq__dropdown",
  "dropdownIcon": "STFooter-module__o2ngqq__dropdownIcon",
  "dropdownLink": "STFooter-module__o2ngqq__dropdownLink",
  "link": "STFooter-module__o2ngqq__link",
  "linkItem": "STFooter-module__o2ngqq__linkItem",
  "linksWrapper": "STFooter-module__o2ngqq__linksWrapper",
  "logoImg": "STFooter-module__o2ngqq__logoImg",
  "rightLinkWrap": "STFooter-module__o2ngqq__rightLinkWrap",
  "scrollTop": "STFooter-module__o2ngqq__scrollTop",
  "socialLink": "STFooter-module__o2ngqq__socialLink",
  "title": "STFooter-module__o2ngqq__title",
});
